<template>
  <div class="base-panel">
    <div class="base-panel-head" :style="{borderColor: headBorderColor}">
      <div class="base-panel-head--title" :style="{color: titleColor}">{{ title }}</div>
      <router-link v-if="link" :to="link" class="base-panel-head--link" target="_blank">
        {{ linkText }}<img src="@/img/common/icon_double_arrow.png" alt="">
      </router-link>
      <div v-if="buttonText" class="base-panel-head--link" @click="onDetailClick">
        {{ buttonText }}<img src="@/img/common/icon_double_arrow.png" alt="">
      </div>
      <span v-if="arrow" class=""><i class="el-icon-arrow-right" /></span>
      <slot name="headRight" />
    </div>
    <div class="base-panel-body" :style="{padding: padding}">
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleColor: {
      type: String,
      default: '#333'
    },
    link: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: '详情'
    },
    buttonText: {
      type: String,
      default: ''
    },
    headBg: {
      type: String,
      default: ''
    },
    headBorderColor: {
      type: String,
      default: '#FFA100'
    },
    padding: {
      type: String,
      default: '0'
    },
    arrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    }
  },
  created() {
    // console.log(this.$listeners)
  },
  methods: {
    onDetailClick() {
      this.$emit('button-click')
    }
  }
}
</script>

<style lang="scss" scoped>
  .base-panel {
    background: #FFFFFF;
    overflow: hidden;
    /*display: flex;*/
    /*flex-direction: column;*/
    .base-panel-head{
      background-color: #fff;
      height: 44px;
      display: flex;
      align-items: center;
      border-bottom: none;
      border: 1px dashed #FFA100;
      padding-left: 14px;
      border-radius: 8px 8px 0 0;
      .base-panel-head--title{
        font-weight: 700;
      }
      .base-panel-head--link{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0 10px;
        height: 24px;
        line-height: 22px;
        background: #E9FFF6;
        border-radius: 13px;
        border: 1px solid #00B66C;
        font-weight: 500;
        color: #00B66C;
        img{
          margin-left: 5px;
          width: 9px;
        }
      }
    }
    .base-panel-body{
      height: calc(100% - 50px);
      border: 1px dashed #FFA100;
      border-radius: 0 0 8px 8px ;

    }
  }
</style>
